import { dataShieldWaveSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconShieldWaveSolid = /*#__PURE__*/createIcon(dataShieldWaveSolid)
export default IconShieldWaveSolid
